<template>
  <div style="padding-bottom: 50px;">
    <router-view :result="result" />
    <Tabbar/>
  </div>
</template>

<script>
import Tabbar from './Tabbar'
export default {
  components: { Tabbar },
  data() {
    return {
      active: 0,
      result: 0
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">

</style>

